export const LineaMorada = () => {
    return(
    <div className="container-fluid">
        <div className="row">
            <div className="col-12 blue_pipe"></div>
        </div>
    </div>    
    )
}